import { EMPTY_VALUE_CHARACTER } from './numbers';

export function getStartMethod(startMethodId) {
  switch (startMethodId) {
    case 'A':
      return 'Autostart';
    case 'V':
      return 'Voltstart';
    case 'L':
      return 'Linjestart';
    default:
      return '';
  }
}

export function formatFirstPrize(race) {
  if (race.first_prize == null) {
    return '';
  }

  if (race.first_prize === 0) {
    return '';
  }

  // Attempt to figure out currency from proposition text,
  // assuming it has the format: `Pris: 10.000-5.000 kr.` or `Pris: 10.000-5.000 (Info här) kr.`
  // TODO: Remove when backend has proper support for this: https://github.com/trmediaab/traisx/issues/4346
  const attemptToExtractCurrency = () => {
    if (!race.proposition) {
      return null;
    }

    const priceRegexp = /Pris: .*? (\w+)\W/g;
    const match = priceRegexp.exec(race.proposition);
    if (match) {
      const guessedCurrency = match[1];
      if (
        ['kr', 'euro', 'EURO', 'EUR', 'nok', 'NOK'].includes(guessedCurrency)
      ) {
        return guessedCurrency;
      }
    }

    return null;
  };

  const currency = attemptToExtractCurrency();

  // Note - Currency format for SEK is 999.999.999,00 but Intl.NumberFormat('sv-SE') has other ideas
  // so we just format to Swedish number format, which is 999 999 999,00 and replace spaces with dots
  const formatted = race.first_prize
    .toLocaleString('sv-SE')
    .replaceAll(/\W/g, '.');
  return currency ? `${formatted} ${currency}` : formatted;
}

export function getDistance(race) {
  if (!race.base_dist) {
    return '';
  }

  return `${race.base_dist} m`;
}

const trackStateMap = {
  L: 'Lätt bana',
  N: 'Något tung bana',
  S: 'Struket lopp',
  T: 'Tung bana',
  V: 'Vinterbana',
};

/**
 * Formats the given track state enum value into a corresponding string representation.
 *
 * @param state - The track state enum value to format.
 * @returns The string representation of the given track state.
 */
export function formatTrackStateEnum(state) {
  return trackStateMap[state];
}

export function parsePlacement(start) {
  let text;

  if ('scratched_info' in start && start.scratched_info != null) {
    text = EMPTY_VALUE_CHARACTER;
  } else if (start.result.dsq) {
    text = 'd';
  } else if (start.result.placement != null) {
    text = start.result.placement.toString();
  } else {
    text = 'n/a';
  }

  return {
    text,
  };
}
